"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mask = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var __1 = require("../");
var Mask = function (_a) {
    var _b = _a.active, active = _b === void 0 ? true : _b, _c = _a.borderRadius, borderRadius = _c === void 0 ? 0 : _c, children = _a.children, className = _a.className, content = _a.content, props = __rest(_a, ["active", "borderRadius", "children", "className", "content"]);
    var MaskClasses = classnames_1.default('Mask', className, {
        'Mask--active': active,
    });
    var MaskOverlayClasses = classnames_1.default('Mask__overlay', {
        'border-radius-1': borderRadius === 1,
        'border-radius-2': borderRadius === 2,
    });
    return (react_1.default.createElement("div", __assign({ className: MaskClasses }, props),
        active && (react_1.default.createElement("div", { className: MaskOverlayClasses }, content ? (react_1.default.createElement(__1.Card, { className: "Mask__card" }, content)) : (react_1.default.createElement(__1.Spinner, { className: "Mask__spinner", container: true })))),
        children));
};
exports.Mask = Mask;
//# sourceMappingURL=Mask.js.map